import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Router } from '@angular/router';

import { catchError } from 'rxjs/operators';
import { Observable, throwError } from "rxjs";
import { NGXLogger } from 'ngx-logger';

import { MessageService } from "../services/message.service";

@Injectable()
export class StatusInterceptor implements HttpInterceptor {

	constructor(private messageService: MessageService,
		private router: Router,
		private logger: NGXLogger) {

	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		this.messageService.clearValidationMessages();

		var result = next.handle(req)
        .pipe(
            catchError(response => {
                if (response instanceof HttpErrorResponse && response.status === 400) {
                    this.logger.error("[API]: Validate error(s).");
                    this.messageService.notifyValidation("Ongeldige data", response.error);
                } else if (response instanceof HttpErrorResponse && response.status === 401) {
                    this.router.navigateByUrl('/logout');
                } else if (response instanceof HttpErrorResponse && response.status === 403) {
                    this.router.navigateByUrl('/forbidden');
                } else if (response instanceof HttpErrorResponse && response.status === 404) {
                    this.logger.error("[API]: Uri niet gevonden.");
                    this.messageService.notifyError("Technische Fout", "Uri niet gevonden.");
                } else if (response instanceof HttpErrorResponse && response.status === 0) {
                    this.logger.error("[API]: Kan geen verbinding maken met de server.");
                    if (response.url?.endsWith('/negotiate?negotiateVersion=1')) {
                        this.router.navigateByUrl('/no-connection');
                    }
                    else {
                        this.logger.error(`[API]: ${response.message}, response.message, response.error.detail`);
                        this.messageService.notifyError("Verbindingsfout", "Verbindingsfout: " + response.url);
                    }
                } else {
                    this.logger.error(`[API]: ${response.message}, response.message, response.error.message, response.error.detail`);
                    this.messageService.notifyError("Technische Fout", response.error.error);
                }
                return throwError(() => response);
            })
        );

    return result;
	}
}